import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=5eca3cd2&scoped=true&lang=pug&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.styl?vue&type=style&index=0&id=5eca3cd2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eca3cd2",
  null
  
)

export default component.exports